/* eslint-disable sort-keys-fix/sort-keys-fix */
// Needed because the order of groups matter, as we want to
// display the categories in this particular order on the design
import DialPhone from 'assets/brand/DialPhone@2x.png';
import Heart from 'assets/brand/Heart@2x.png';
import HeartBox from 'assets/brand/HeartBox@2x.png';
import Shield from 'assets/brand/shield@2x.png';
import { Group, GroupItemWithOfferKeys } from 'features/Insurance/types';

import locales from './locales';

export const groups = {
  travel: {
    description: locales.groups.travel.description,
    icon: Heart,
    title: locales.groups.travel.title,
    offers: ['transportDelay', 'healthCostsAbroad', 'rentalVehicle'],
  },
  legal: {
    description: locales.groups.legal.description,
    icon: DialPhone,
    title: locales.groups.legal.title,
    offers: ['legalAssistance', 'debtRecovery'],
  },
  payment: {
    description: locales.groups.payment.description,
    icon: Shield,
    title: locales.groups.payment.title,
    offers: ['paymentFraud', 'phishing'],
  },
  materialAndBody: {
    description: locales.groups.materialAndBody.description,
    icon: HeartBox,
    title: locales.groups.materialAndBody.title,
    offers: [
      'hospitalization',
      'mobileScreen',
      'purchaseProtection',
      'computerBreakage',
    ],
  },
} satisfies Record<Group, GroupItemWithOfferKeys>;
